import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["select", "preview", "loading", "submit", "summary"];
  static values = { url: String };

  connect() {
    this.choice = "keep";

    if (this.selectTarget.value) {
      this.preview();
    }
  }

  preview() {
    const timeZone = this.selectTarget.value;

    this.submitTarget.disabled = true;
    this.summaryTarget.textContent = "";
    this.previewTarget.innerHTML = "";

    if (!timeZone) {
      return;
    }

    this.loadingTarget.classList.remove("d-none");

    this.fetchHtml(`${this.urlValue}?time_zone=${encodeURIComponent(timeZone)}`)
      .then((html) => {
        if (this.selectTarget.value !== timeZone) {
          return;
        }

        this.loadingTarget.classList.add("d-none");
        this.previewTarget.innerHTML = html;
        this.applyChoice();
        this.submitTarget.disabled = false;
      })
      .catch(() => {
        if (this.selectTarget.value !== timeZone) {
          return;
        }

        this.loadingTarget.classList.add("d-none");
        this.previewTarget.innerHTML = '<div class="tz-change__banner tz-change__banner--error">We couldn\'t load a preview for that time zone. Please try again.</div>';
      });
  }

  choose(event) {
    this.choice = event.target.value === "true" ? "keep" : "shift";
    this.applyChoice();
  }

  applyChoice() {
    const result = this.previewTarget.querySelector("[data-time-zone-change-choice]");

    if (!result) {
      return;
    }

    result.dataset.timeZoneChangeChoice = this.choice;

    result.querySelectorAll('input[name="migrate_bookings"][type="radio"]').forEach((input) => {
      input.checked = input.value === (this.choice === "keep" ? "true" : "false");
      input.closest(".tz-change__choice").classList.toggle("is-selected", input.checked);
    });

    this.summaryTarget.textContent = (this.choice === "keep" ? result.dataset.keepSummary : result.dataset.shiftSummary) || "";
  }

  showMore(event) {
    event.preventDefault();

    const link = event.currentTarget;
    const row = link.closest(".tz-change__more");

    if (link.classList.contains("disabled")) {
      return;
    }

    link.classList.add("disabled");
    link.textContent = "Loading ...";

    this.fetchHtml(link.href)
      .then((html) => {
        row.outerHTML = html;
      })
      .catch(() => {
        link.classList.remove("disabled");
        link.textContent = "Couldn't load more. Try again.";
      });
  }

  fetchHtml(url) {
    return fetch(url, { headers: { "X-Requested-With": "XMLHttpRequest" } }).then((response) => {
      if (!response.ok) {
        throw new Error(`Request failed with ${response.status}`);
      }

      return response.text();
    });
  }
}
